import kebabCase from "lodash/kebabCase";
import { createSelector } from "reselect";
import { getConfigOption } from "./selector.configOptions.jsx";
import { getLoggedUser } from "./selector.users.jsx";

const getInstanceId = (state) => state.instance;

export const makeLoggedUserRealTimeChannelNameSelector = () => {
  return createSelector(
    (state) => getConfigOption(state, `on_demand`),
    getInstanceId,
    (state) => getLoggedUser(state).id,
    (isCloudUser, instanceId, userId) => {
      return `private-${isCloudUser ? `instance-${instanceId}-` : ``}user-${userId}`;
    }
  );
};

export const getPresenceChannelName = createSelector(
  (state) => getConfigOption(state, `on_demand`),
  getInstanceId,
  (isCloudUser, instanceId) => {
    const instance = isCloudUser ? `-instance-${instanceId}` : ``;
    return `presence${instance}`;
  }
);

export const getGlobalPresenceChannelName = createSelector(getPresenceChannelName, (name) => `${name}-global`);

export const makeObjectPresenceChannelNameSelector = (objectType) => {
  objectType = kebabCase(objectType);
  return createSelector(
    getPresenceChannelName,
    (state, id) => id,
    (presenceChannelName, id) => {
      return `${presenceChannelName}-${objectType}-${id}`;
    }
  );
};
